import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import TitleWrapper from "../../../components/ui/titlewrapper/TitleWrapper";

const initState = {
  decisionComment: ''
};

export const OthersData = {
  name: "EditMembershipTaskListFormData",
  initialState: initState,
  section: [
    {
      title: "Notification Section",
      row: {},
      style: {
        sectionStyle: "verticle-form mb-3 form-card row",
      },

      wrapperTemplate: <TitleWrapper title="Notification To Attendees (Email)" />,

      fields: [
        {
          id: "decisionComment",
          label: "After completing their booking, the customer will get a confirmation email. Below is where you type text for this email. E.g. include information about parking / where to meet / finish time / what to bring / what to wear etc.",
          Field_Name: "Comments",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "decisionComment",
          fieldSetting: {
            placeholder: "Please Enter Comment",
            allowSpace: true,
            textareaRows: 4,
          },
          //validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 small-title",
          },
        },
      ],
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
